import React, { FunctionComponent, useState } from 'react';
import { ProductType } from 'Quotes/types/productTypes';
import Button from 'shared/components/atoms/Button';
import TermsText, { OPENREACH_SURCHARGE_TEXT } from './components/TermsText';
import { IRequestState } from 'shared/types/requestState';

type Props = {
  productType: ProductType;
  showGeaCablelinkNotice: boolean;
  showOpenreachCPENotice: boolean;
  showAdditionalOpenreachSurchargeNotice: boolean;
  submitting: IRequestState;
  onSubmit(): void;
};

const Terms: FunctionComponent<React.PropsWithChildren<Props>> = ({
  onSubmit,
  productType,
  showGeaCablelinkNotice,
  showOpenreachCPENotice,
  showAdditionalOpenreachSurchargeNotice,
  submitting,
}) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [openreachCPEAccepted, setOpenreachCPEAccepted] = useState(!showOpenreachCPENotice);
  const [openreachSurchargeAccepted, setOpenreachSurchargeAccepted] = useState(false);
  const onChangeOpenreachCPE = () => {
    setOpenreachCPEAccepted(!openreachCPEAccepted);
  };
  const onChangeOpenreachSurcharge = () => {
    setOpenreachSurchargeAccepted(!openreachSurchargeAccepted);
  };
  const onChangeTermsChkBox = () => {
    setTermsAccepted(!termsAccepted);
  };

  return (
    <div>
      <TermsText
        productType={productType}
        showGeaCablelinkNotice={showGeaCablelinkNotice}
        showOpenreachCPENotice={showOpenreachCPENotice}
        showAdditionalOpenreachSurchargeNotice={showAdditionalOpenreachSurchargeNotice}
        onToggleTerms={onChangeTermsChkBox}
      />
      {showOpenreachCPENotice && (
        <div className="form-check pb-1">
          <input
            type="checkbox"
            id="openreach-cpe-checkbox"
            checked={openreachCPEAccepted}
            className="form-check-input"
            onChange={onChangeOpenreachCPE}
          />
          <label htmlFor="openreach-cpe-checkbox" className="form-check-label">
            Please tick to confirm your device(s) is MCT compliant.
          </label>
        </div>
      )}
      {showAdditionalOpenreachSurchargeNotice && (
        <div className="form-check pb-3">
          <input
            type="checkbox"
            id="openreach-surcharge-checkbox"
            checked={openreachSurchargeAccepted}
            className="form-check-input"
            onChange={onChangeOpenreachSurcharge}
          />
          <label htmlFor="openreach-surcharge-checkbox" className="form-check-label">
            {OPENREACH_SURCHARGE_TEXT}
          </label>
        </div>
      )}
      <Button
        disabled={
          !termsAccepted ||
          !openreachCPEAccepted ||
          (showAdditionalOpenreachSurchargeNotice && !openreachSurchargeAccepted) ||
          submitting.inProgress
        }
        onClick={onSubmit}
        className="submitOrder--btn"
      >
        Submit for review
      </Button>
    </div>
  );
};

export default Terms;
